/* eslint-disable react/prop-types */
import React from 'react';
import { components } from 'react-select';
import './Option.css';

const CheckboxOption = (props) => {
  const { children, value, isSelected } = props;

  return (
    <components.Option {...props}>
      <span className="checkbox-container">
        <input type="checkbox" aria-hidden="true" name={value} checked={isSelected} className="checkbox-field" />
        <div className="checkbox-label">{children}</div>
        <span className="checkbox-checkmark" />
      </span>
    </components.Option>
  );
};

export default CheckboxOption;
